import "./LandDetails.css";
import { calculateDownPayment, calculateInstallments, formattedPrice } from "../../../../utils";
import PdfIcon from "../../../../assets/icons/PdfIcon";
import { PDFDownloadLink } from "@react-pdf/renderer";
import LandDetailsPdf from "../../../../features/Pdfs/LandDetailsPdf";

const LandDetails = ({ land, onDownload }) => {
  /*const getStatus = (status) => {
    return t(`lotLandFormPage.${status}`);
  };*/

  return (
    <div className="p-4">
      {/* <div className="mb-1">
                <div className="label-details">{'Estado'}</div>
                <div className="text">{getStatus(land?.status)}</div>
            </div> */}
      <div className="mb-2">
        <div className="label-details">{"Nombre"}</div>
        <div className="text">{land?.identifying_label}</div>
      </div>
      <div className="mb-2">
        <div className="label-details">Enganche</div>
        <div className="text">
          {land?.total ? formattedPrice(calculateDownPayment(land?.total)?.down_payment) : ''}
          {/*formattedPrice(land?.advance)*/}
          {/*<NumericFormat 
                        value={land?.advance} 
                        allowLeadingZeros 
                        thousandSeparator=","
                        prefix={'$'}
                    />*/}
        </div>
      </div>
      <div className="mb-2">
        <div className="label-details">Precio</div>
        <div className="text">
          {formattedPrice(land?.total)}
          {/*<NumericFormat 
                        value={land?.price} 
                        allowLeadingZeros 
                        thousandSeparator=","
                        prefix={'$'}
                    />*/}
        </div>
      </div>
      <div className="mb-2">
        <div className="label-details">Descuento</div>
        <div className="text">0%</div>
      </div>
      <div className="mb-2">
        <div className="label-details">Mensualidad</div>
        <div className="text">{land?.total ?formattedPrice(calculateInstallments(land?.total, calculateDownPayment(land?.total)?.down_payment)?.installment) : ''}{' (120 meses)'}</div>
      </div>
      <div className="mb-2">
        <div className="label-details">{"Medidas"}</div>
        <div className="text">{land?.surface || "Sin medidas"}</div>
      </div>
      {/* <div className="mb-1">
                <div className="label-details">{'Adelanto'}</div>
                <div className="text">{land?.advance}</div>
            </div> */}
      {/* <div className="mb-1">
                <div className="label-details">{'Medidas'}</div>
                <div className="text">{land?.measurements || 'Sin medidas'}</div>
            </div>
            <div className="mb-1">
                <div className="label-details">{'Superficie'}</div>
                <div className="text">{land?.surface || 'Sin superficie'}</div>
            </div> */}
      <div className="mb-3">
        <div className="label-details">{"Descripción"}</div>
        <div className="text">{land?.description || "Sin descripción"}</div>
      </div>
      <div className="mb-2">
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-col">
            <p
              className="label-details p-0"
              style={{ fontSize: "16px", paddingTop: 15, lineHeight: 0 }}
            >
              Informacion completa de PDF
            </p>
            <PDFDownloadLink
              document={<LandDetailsPdf
                name={land?.identifying_label || ''}
                engage={land?.advance || ''}
                interest={0}
                mensualidad={120}
                media={land?.surface || ''}
                ubication={land?.location || ''}
                description={land?.description || ''}
                price={formattedPrice(land?.total) || ''}
              />}
              fileName="Informacion.pdf"
              className="label-details underline hover:cursor-pointer p-0"
              style={{
                fontSize: "16px",
                lineHeight: "0%",
                paddingTop: 15,
                paddingBottom: 15,
              }}
            >
              {({ loading }) => (loading ? 'Generando PDF...' : 'Descárgalo aquí')}
            </PDFDownloadLink>
          </div>
          <PdfIcon size="40" />
        </div>
      </div>
    </div>
  );
};

export default LandDetails;
